import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export const SealDialog = ({ count, target, onSeal, trigger, open, onOpenChange }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}
    <AlertDialogContent data-testid="seal-dialog" className="lab-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display uppercase tracking-widest">Seal the vocabulary?</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">
          {count} of {target} words programmed. Sealing locks every object, hides Setup from the kiosk and starts the
          experiment from zero. You can unseal later from this page.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="seal-cancel" className="lab-btn-ghost">Not yet</AlertDialogCancel>
        <AlertDialogAction data-testid="seal-confirm" className="lab-btn-primary" onClick={onSeal}>Seal &amp; begin</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
